// EditHistoryButton - りれきボタン（アセットバーの右に隣接）
// 白い角丸スクエア + オレンジ履歴アイコン + りれきラベル + 件数バッジ。タップで EditHistoryModal を開く。
// 配置・スケールは親（AssetBar）が担うため、ここではインラインのボタンのみを返す。

import { useState } from "react";
import { useSelector } from "react-redux";
import HistoryIcon from "@mui/icons-material/History";
import { RootState } from "app/store";
import I18n from "common/i18n";
import { usePlaySound, btnDelay } from "common/utils";
import { EditHistoryModal } from "./EditHistoryModal";

export const EditHistoryButton = () => {
  const play = usePlaySound();
  const editHistory = useSelector((state: RootState) => state.builder.editHistory);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    play();
    btnDelay(() => setOpen(true));
  };

  return (
    <>
      <button
        data-guide="history_open"
        onClick={handleOpen}
        aria-label={I18n.t("MSG_BUILDER_EDIT_HISTORY")}
        className="relative flex-col-el flex-center gap-1 w-24 h-24 box-border rounded-2xl bg-white border-2 border-white shadow-lg active:scale-95 transition-transform type-inherit-font"
      >
        <span className="flex-col-el flex-center type-hero text-orange-100">
          <HistoryIcon fontSize="inherit" />
        </span>
        <span className="type-sm text-textcolor-black whitespace-nowrap">
          {I18n.t("MSG_BUILDER_EDIT_HISTORY_SHORT")}
        </span>
        {editHistory.length > 0 && (
          <span className="flex-col-el flex-center absolute top-1 right-1 min-w-6 h-6 px-1 box-border rounded-full bg-orange-100 type-sm text-white whitespace-nowrap">
            {editHistory.length}
          </span>
        )}
      </button>

      <EditHistoryModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
